(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zydo-ships-within"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zydo-ships-within')) {
    customElements.define('zydo-ships-within', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.closest('form');
        this.valueElement = this.querySelector('[data-zydo-shipping-value]');
        const dataElement = this.querySelector('[data-zydo-variant-shipping]');
        if (!this.form || !this.valueElement || !dataElement) return;
        try {
          const variants = JSON.parse(dataElement.textContent);
          this.variantTimes = new Map(variants.map(variant => [String(variant.id), variant.madeToOrder]));
        } catch {
          this.hidden = true;
          return;
        }
        this.controller = new AbortController();
        this.eventSequence = 0;
        const signal = this.controller.signal;
        const initialInput = this.form.querySelector('[name="id"]');
        this.setVariant(initialInput?.value || this.dataset.selectedId);
        const scheduleUpdate = () => {
          const sequence = this.eventSequence;
          queueMicrotask(() => {
            if (signal.aborted || sequence !== this.eventSequence) return;
            const input = this.form.querySelector('[name="id"]');
            this.setVariant(input ? input.value : null);
          });
        };
        this.form.addEventListener('change', scheduleUpdate, { capture: true, signal });
        this.form.addEventListener('click', scheduleUpdate, { capture: true, signal });
        window.addEventListener('popstate', scheduleUpdate, { signal });
        const bindThemeEvent = () => {
          if (!window.jQuery || this.themeHandler || signal.aborted) return;
          this.themeHandler = (event, args) => {
            if (String(args?.product?.id) !== this.dataset.productId) return;
            this.eventSequence += 1;
            this.setVariant(args?.variant?.id);
          };
          window.jQuery(window).on('cc-variant-updated', this.themeHandler);
        };
        bindThemeEvent();
        window.addEventListener('load', bindThemeEvent, { once: true, signal });
      }
      setVariant(id) {
        const key = String(id ?? '');
        if (!this.variantTimes.has(key)) {
          this.hidden = true;
          return;
        }
        this.valueElement.textContent = this.variantTimes.get(key)
          ? this.dataset.madeToOrderTime
          : this.dataset.standardTime;
        this.hidden = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.themeHandler && window.jQuery) {
          window.jQuery(window).off('cc-variant-updated', this.themeHandler);
        }
        this.themeHandler = null;
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
